import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

const initGallery = (section) => {
    const msnry = new Masonry(section, {
        itemSelector: '.js-gallery-card',
        columnWidth: '.js-gallery-card',
        percentPosition: true
    });

    imagesLoaded(section).on('progress', () => {
        msnry.layout();
    });
};

export default initGallery;
